import { DynamicInputBase } from './dynamic-input-base';

export class TextboxInput extends DynamicInputBase<any> {
  controlType = 'textbox';
}
